import Vue from 'vue';
import 'es6-promise/auto'; // required before vuex
import Vuex from 'vuex';

import actions from './actions';
import mutations from './mutations';

import addressBook from './modules/addressBook';
import cart from './modules/cart';
import colorAdvisor from './modules/colorAdvisor';
import constants from './modules/constants';
import customer from './modules/customer';
import modal from './modules/modal';
import moreColorOptions from './modules/moreColorOptions';
import notifications from './modules/notifications';
import payments from './modules/payments';
import pdp from './modules/pdp';
import refillCart from './modules/refillCart';
import subscriptions from './modules/subscriptions';
import waitlist from './modules/waitlist';
import xsell from './modules/xsell';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  actions,
  mutations,
  modules: {
    addressBook,
    cart,
    colorAdvisor,
    constants,
    customer,
    modal,
    moreColorOptions,
    notifications,
    payments,
    pdp,
    refillCart,
    subscriptions,
    waitlist,
    xsell
  }
});

export default store;
